<div class="percent-ring" [style.width.px]="size" [style.height.px]="size">
  <svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="'0 0 ' + size + ' ' + size">
    <circle
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      fill="none"
      [attr.stroke]="trackColor"
      [attr.stroke-width]="strokeWidth"
    />
    <circle
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      fill="none"
      [attr.stroke]="primaryColor"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="primaryDasharray"
      stroke-linecap="round"
      [attr.transform]="'rotate(-90 ' + center + ' ' + center + ')'"
    />
    <circle
      *ngIf="clampedExtraPercent > 0"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      fill="none"
      [attr.stroke]="extraColor"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke-dasharray]="extraDasharray"
      [attr.stroke-dashoffset]="extraDashoffset"
      stroke-linecap="round"
      [attr.transform]="'rotate(-90 ' + center + ' ' + center + ')'"
    />
  </svg>
  <div class="percent-ring__value">
    <span class="percent-ring__main">{{ clampedPercent }}%</span>
    <span class="percent-ring__extra" *ngIf="clampedExtraPercent > 0">+{{ clampedExtraPercent }}%</span>
  </div>
</div>
